import request from '@/utils/request'

export function getAgencyInformation(params) {
    return request({
        url: 'agent_admin/agency/hotchat/details',
        method: 'get',
        params
    })
}